var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-item',{staticClass:"mt-1 mr-1",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('div',{staticClass:"selectable-item pa-2 d-inline-block",on:{"click":toggle}},[_c('span',[_vm._v(_vm._s(_vm.id))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }